import { requestJson } from '@/shared/api/http'
import type { IntelReport } from '../model/contracts'
import { parseIntelReport } from './intelCodec'

export async function fetchLatestIntel(
  topicId: string,
  signal?: AbortSignal,
): Promise<IntelReport> {
  return requestJson<IntelReport>(`/api/v1/topics/${topicId}/intel/latest`, {
    method: 'GET',
    signal,
  }).then(parseIntelReport)
}
